import { getFunctions, httpsCallable } from 'firebase/functions';
import { initializeApp } from 'firebase/app';
import { userService } from '../user.service';
import {bms_firebaseConfig} from '../fb/config';
const bms_app = initializeApp(bms_firebaseConfig,'BMS_APP');

export const callFunc = async (name: string, payload: any = {}, method = ''): Promise<any> => {
	const userInfo = userService.getCurrentUser();
	const data: any = {
		payload: {
			...payload,
			usrid: userInfo?.usrid || 0
		},
		vx: {},
	};
	if (method) data.vx.method = method;
	try {
		const result = await httpsCallable(getFunctions(bms_app, 'asia-south1'), name)(data);
		return result.data;
	} catch (error: any) {
		console.error('Error calling function:', error);
		return { success: false, error: 'Duplicate data' };
	}
};